export type Shell = 'desktop' | 'kiosk' | 'mobile';

export function detectShell(pathname: string): Shell {
  if (pathname.startsWith('/m')) return 'mobile';
  if (pathname.startsWith('/kiosk')) return 'kiosk';
  return 'desktop';
}
